import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

function DownloadNotice() {
  const [logo, setLogo] = useState("");
  const [visible, setVisible] = useState(true);
  const location = useLocation();
  // Derive base domain (strip www, TLDs like .in, .live, .com, etc.)
  const hostname = window.location.hostname.toLowerCase();
  const tldParts = ["com","in","live","net","org","co","io","app","dev","cloud","site","vip"];
  const segments = hostname.replace(/^www\./,'').split('.');
  // Remove trailing TLD segments
  while (segments.length > 1 && tldParts.includes(segments[segments.length - 1])) {
    segments.pop();
  }
  const baseDomain = segments[segments.length - 1];

  // ✅ Fetch logo once
  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logo`);
        if (!response.ok) throw new Error("Failed to fetch logo");
        const data = await response.json();
        setLogo(`${process.env.REACT_APP_API_URL}/storage/${data[0].favicon}`);
      } catch (error) {
        console.error("Error fetching logo:", error);
      }
    };
    fetchLogo();
  }, []);

  // ✅ Clear flag on real browser reload (only once)
  useEffect(() => {
    // This event fires only on actual reload or closing tab
    window.addEventListener("beforeunload", () => {
      sessionStorage.removeItem("download_bar_closed");
    });
  }, []);

  // ✅ Check sessionStorage for "closed" state
  useEffect(() => {
    const closedOnce = sessionStorage.getItem("download_bar_closed");
    setVisible(closedOnce !== "true");
  }, [location]); // triggers on route change

  // ✅ Close handler
  const handleClose = () => {
    sessionStorage.setItem("download_bar_closed", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="row download-bar no-gutters">
      <button
        type="button"
        onClick={handleClose}
        className="v-icon notranslate mr-2 v-icon--link mdi mdi-close theme--dark"
      />
      <img width={32} height={32} src={logo} alt="download" className="mr-2" />
      <div className="col">
        <label>Download our APP version now! 🚀</label>
      </div>
      <a
        href={`./app/${baseDomain}.apk`}
        className="download-bar-button subtitle-1 v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default"
      >
        <span className="v-btn__content">Download</span>
      </a>
    </div>
  );
}

export default DownloadNotice;
